<template>
	<div class="page d-flex">
		<MenuComponent />
		<DeveloperListViewComponent />
		</div>
</template>

<script>

import MenuComponent from '@/components/user/layout/MenuComponent.vue';
import DeveloperListViewComponent from '@/components/user/viewComponent/developerList/DeveloperListViewComponent.vue';

export default{
	name: 'DeveloperListView',
		components:{
			MenuComponent,
			DeveloperListViewComponent,
		}
}

</script>
